module.exports = __webpack_public_path__ + "static/media/image (19).7f990c22.jpg";